// src/services/authLock.js
const LOCK_KEY = "freelancer_bot_active_user";

export function getActiveUser() {
  const raw = localStorage.getItem(LOCK_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function setActiveUser(username) {
  localStorage.setItem(LOCK_KEY, JSON.stringify({
    username,
    ts: Date.now()
  }));
}

export function clearActiveUser() {
  localStorage.removeItem(LOCK_KEY);
}
